import React, { Component, Fragment } from "react";
import Button from "../../../components/atoms/Button";
import TextBox from "../../../components/atoms/TextBox";
import SelectFiles from "../../../components/atoms/SelectFiles";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import TextArea from "../../../components/atoms/TextArea";
import Loading from "../../../components/molecules/Loading";
import InformationText from "../../../components/molecules/InformationText";
import { URL_API_FILE_FINANCE_STATEMENT } from "../../../config/api";
import UploadOneImages from "../../../utils/actions/UploadOneImages";
import curencyFormat from "../../../utils/helpers/curencyFormat";
import ModalInformation from "../ModalInformation";

export class DataDokumenNew extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
			mutation_file: {
				error: null,
				loading: false,
				link: "",
			},
			financial_statement_file: {
				error: null,
				loading: false,
				link: "",
			},
			load_next: false,
			comfirmedSubmit: false,
		};
	}

	componentDidMount = () => {
		this._isMounted = true;
		this.props.ResetStatusState();
	};

	componentWillUnmount = () => {
		this._isMounted = false;
	};

	componentDidUpdate = (prevProps) => {
		if (this.props.detailPinjaman.detail !== prevProps.detailPinjaman.detail) {
			if (this.props.detailPinjaman.detail !== null) {
				const { infoDocs } = this.props.detailPinjaman.detail;

				if (this._isMounted) {
					this.setState({
						mutation_file: {
							...this.state.invois,
							link: infoDocs.mutation ? infoDocs.mutation.url : "",
						},
						financial_statement_file: {
							...this.state.invois,
							link: infoDocs.financialStatement ? infoDocs.financialStatement.url : "",
						},
					});
				}
			}
		}
	};

	setStateList = (parent, child, value) => {
		if (this._isMounted) {
			this.setState({
				[parent]: {
					...this.state[parent],
					[child]: value,
				},
			});
		}
	};

	uploadFile = (name, value) => {
		const { RefreshToken } = this.props;
		const { loanCode } = this.props.match.params;
		this.setStateList(name, "loading", true);

		let url = null;
		RefreshToken((ClientID) => {
			if (ClientID) {
				UploadOneImages(URL_API_FILE_FINANCE_STATEMENT(loanCode), { name: name, file: value }, ClientID, (hasil, error) => {
					this.setStateList(name, "loading", false);
					if (!error) {
						url = name == "mutation_file" ? hasil.document.mutation.url : hasil.document.financialStatement.url;
						this.setStateList(name, "link", url);
					} else {
						this.setStateList(name, "error", error);
					}
				});
			}
		});
	};

	onSubmitStep = () => {
		const { mutation_file, financial_statement_file } = this.state;
		const { SetError } = this.props;

		if (mutation_file.link == "" || financial_statement_file.link == "") {
			SetError("Dokumen belum lengkap, periksa kembali");
		} else {
			if (this._isMounted) {
				this.setState({
					comfirmedSubmit: true,
				});
			}
		}
	};

	render() {
		const { detailPinjaman, col, status, goBack, submitDraf } = this.props;
		const { mutation_file, financial_statement_file, load_next, comfirmedSubmit } = this.state;
		const modalProps = {
			show: comfirmedSubmit,
			title: "Perubahan terakhir",
			content: "Setalah dikirim, data sudah tidak dapat diubah kembali. Apakah Anda yakin?",
			icon: "/img/icon/Warning-Big.png",
			actYes: {
				title: "KIRIM",
				action: () => {
					if (this._isMounted) {
						this.setState({
							load_next: true,
							comfirmedSubmit: false,
						});
						submitDraf(() => {
							this.setState({
								load_next: false,
							});
						});
					}
				},
			},
			actNo: {
				title: "BATAL",
				action: () => {
					if (this._isMounted) {
						this.setState({
							comfirmedSubmit: false,
						});
					}
				},
			},
			actClose: () => {
				if (this._isMounted) {
					this.setState({
						comfirmedSubmit: false,
					});
				}
			},
		};

		return (
			<Fragment>
				<Loading display={detailPinjaman.loading} />
				<LabelWithInput label="Unggah Mutasi Rekening per Semester Terakhir" col={col} {...this.props} info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB" note={mutation_file.error}>
					<SelectFiles
						name="mutation_file"
						extention=".pdf,.png,.jpg,.jpeg"
						onChange={(name, value) => {
							this.uploadFile(name, value);
						}}
						loading={mutation_file.loading}
						files={mutation_file.link}
					/>
				</LabelWithInput>

				<LabelWithInput label="Unggah Laporan Keuangan per Semester Terakhir" col={col} {...this.props} info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 10 MB" note={financial_statement_file.error}>
					<SelectFiles
						name="financial_statement_file"
						extention=".pdf,.png,.jpg,.jpeg"
						onChange={(name, value) => {
							this.uploadFile(name, value);
						}}
						loading={financial_statement_file.loading}
						files={financial_statement_file.link}
					/>
				</LabelWithInput>

				<div className="bg-button">
					<Button title="Kembali" color="outline" width="big" onClick={() => goBack()} />
					<Button title="Kirim" color="blue" width="big" loading={status.loading && load_next} onClick={() => this.onSubmitStep()} />
				</div>

				<ModalInformation {...modalProps} />
			</Fragment>
		);
	}
}

export default DataDokumenNew;
